import React from 'react'
import { FormattedMessage } from 'react-intl'
import FormattedCurrency from 'js/components/FormattedCurrency'

type Props = {
  price: number
  originalPrice: number
  isRegularPrice: boolean
  currency: string
  duration: number
}

export default function BestPlanInfo({
  price,
  currency,
  duration,
  originalPrice,
  isRegularPrice,
}: Props) {
  return (
    <div
      className={`
        top- absolute
        right-0 top-0 z-20
        mr-20 -translate-y-1/2
        transform 
        text-center 
        lg:mr-0 lg:w-full
        lg:translate-x-0`}
    >
      <span
        className={`
        z-20 whitespace-nowrap
      rounded-4 border-2 border-LSWarning bg-LSWarning
        px-8 py-2
        text-red type-14-demibold-caps lg:rounded-8 lg:px-32 lg:py-8
      `}
      >
        <span
          className="absolute right-0 mr-30 translate-y-1/2 transform"
          style={{
            width: 0,
            height: 0,
            borderTop: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderRight: '10px solid rgb(246, 217, 213)',
          }}
        ></span>
        <span className="relative z-20">
          {!isRegularPrice ? (
            <FormattedMessage
              defaultMessage="Save {amount}!"
              id="chooseSubscription.save"
              values={{
                amount: (
                  <FormattedCurrency
                    value={(originalPrice - price) * duration}
                    currency={currency}
                  />
                ),
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Save {amount}/mon!"
              id="chooseSubscription.savePerMonth"
              values={{
                amount: (
                  <FormattedCurrency
                    value={originalPrice - price}
                    currency={currency}
                  />
                ),
              }}
            />
          )}
        </span>
      </span>
    </div>
  )
}
